/* eslint-disable no-prototype-builtins */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable radix */
import React from 'react';
import OrderLevelProgress from './ProgressBar/OrderLevelProgress';

export default function StatusProgressbar({ OrderDetails }) {
    return (
        <div className="mt-3 border border-[#CBC7C7] rounded-md py-2.5 px-5 relative">
            <p className="text-sm font-semibold text-[#090406]">Approval Status</p>
            <div className="mt-3.5 overflow-x-auto custom-scrollbar">
                <div className="pt-4 pb-2 pl-[30px]">
                    <OrderLevelProgress OrderDetails={OrderDetails} />
                </div>
                <div className="flex pl-[30px]">
                    {OrderDetails.approvals.approval.map((item, index) => (
                        <div style={{ minWidth: `${(100 / OrderDetails.approvals.approval.length).toFixed(2)}%` }}>
                            <p className="text-xs font-semibold text-[#555259]">
                                {item.role_name}
                            </p>
                            <p className="text-xs12 font-semibold text-[#800005]">
                                <span className={parseInt(item.status) === 0 ? 'text-[orannge]' : parseInt(item.status) === 1 ? 'text-[green]' : 'text-[red]'}>
                                    {parseInt(item.status) === 0 ? 'Pending' : parseInt(item.status) === 1 ? 'Approved' : 'Rejected'}
                                </span>
                            </p>
                            <button
                                className="text-xs12 font-normal text-[#777777] w-[150px] text-left relative"
                                onMouseEnter={(e) => { e.target.nextElementSibling.classList.toggle('hidden'); }}
                                onMouseLeave={(e) => { e.target.nextElementSibling.classList.toggle('hidden'); }}
                                type="button"
                            >
                                <span className="font-semibold">Note:</span>
                                {' '}
                                {item.note.slice(0, 50)}
                            </button>
                            <div id={`tooltip-hoveruuuuu${index}`} role="tooltip" style={{ left: `${(index * (100 / OrderDetails.approvals.approval.length)).toFixed(2)}%` }} className="inline-block absolute py-2.5 px-2 rounded-lg top-0 hidden shadow-s11 w-[200px] bg-[#ffffff]">
                                <p className="text-xs font-semibold text-[#555259]">{item.role_name}</p>
                                <p className="text-xs12 font-semibold text-[#800005] pt-0.5">
                                    <span className="text-[green]">{parseInt(item.status) === 0 ? 'Pending' : parseInt(item.status) === 1 ? 'Approved' : 'Rejected'}</span>
                                </p>
                                <p className="text-xs12 font-normal text-[#555259] pt-0.5">
                                    {item.note}
                                </p>
                                <div className="tooltip-arrow" data-popper-arrow />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
